import cache from 'lscache';

import { fetchRequest, handleError } from './utils/RestApi';
import { minutesToMidnight } from '../utils/utils';

export const DEFAULT_LOCALE = 'en-GB';

const translationStorageKey = 'phrase';
export const phraseAppToken = '6635bd42f1aaf2d3ddcb45d271c44651711b2da17c9d17ca48cbf472090860d5';
export const phraseAppProjectId = 'c429aeada23b763b222bfda686b9848f';

export type Translations = { [x: string]: string };

export interface PhraseResponseRaw {
  code: string;
  name: string;
}

export interface PhraseLocale {
  language: string;
  locale: string;
  selected?: boolean;
}

export const getAvailableLanguages = async (): Promise<PhraseLocale[]> => {
  const key = `${translationStorageKey}-locales`;
  const storedLocales = cache.get(key);
  if (storedLocales) {
    return storedLocales;
  }

  const url = `https://api.phrase.com/v2/projects/${phraseAppProjectId}/locales`;
  const headers = new Headers();
  headers.set('Authorization', `token ${phraseAppToken}`);

  try {
    const response = await fetchRequest({ url, method: 'GET', headers });
    const locales: PhraseResponseRaw[] = await response.json();
    const result = locales.map(locale => ({ language: locale.code.split('-')[0].toUpperCase(), locale: locale.name }));
    cache.set(key, result, minutesToMidnight());

    return result;
  } catch {
    return handleError();
  }
};

export const getTranslations = async (locale: string) => {
  const key = `${translationStorageKey}-translations-${locale}`;
  const storedTranslations = cache.get(key);
  if (storedTranslations) {
    return storedTranslations;
  }

  const url = `https://api.phrase.com/v2/projects/${phraseAppProjectId}/locales/${locale}/download?file_format=simple_json`;
  const headers = new Headers();
  headers.set('Authorization', `token ${phraseAppToken}`);

  try {
    const response = await fetchRequest({ url, method: 'GET', headers });
    const translations = await response.json();
    cache.set(key, translations, minutesToMidnight());

    return translations;
  } catch {
    return handleError();
  }
};
